import { defineStore } from 'pinia'
import AuthService from "@/services/auth.service";
import CommonService from "@/services/common.service";
export const useAccountStore = defineStore('account', {
  state: () => {
    return {
      account: {},
      isLogin: false,
      auth: null
    }
  },
  persist: true,
  actions: {
    async login(url, params) {
      try {
        const account = await AuthService.login(url, params)
        this.account = account.data.data
        this.isLogin = true
        CommonService.setTokenAuth({
          'accessToken' : this.account?.token.accessToken,
          'refreshToken' : this.account?.token.refreshToken,
          'username' : this.account?.user_name,
          'userid' : this.account?.id,
          'company_id' : this.account?.company?.id,
          'company_zip' : this.account?.company?.company_zip,
          'company_name' : this.account?.company?.company_name,
        })
      } catch (e) {
        return e
      }
    },
    async logout(url, params) {
      try {
        await AuthService.logout(url, params)
        this.account = {}
        this.isLogin = false
      } catch (e) {
        return null
      }
    },
  }
})
